import { styled } from "@mui/material/styles";
import { Box, Typography, Paper, TableCell, TextField, Button } from "@mui/material";

export const PageContainer = styled(Box)(({ theme }) => ({
    padding: theme.spacing(3),
    minHeight: "30vh",
    color: "white",
    [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(2),
        minHeight: "25vh",
    },
}));

export const HeaderTitle = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(2),
    color: "black",
    fontSize: "1rem",
    [theme.breakpoints.up("md")]: {
        fontSize: "1.25rem",
    },
}));

export const StyledTableContainer = styled(Paper)(({ theme }) => ({
    marginBottom: theme.spacing(3),
    width: "100%",
    overflowX: "auto",
}));

export const StyledTableHeadCell = styled(TableCell)(({ theme }) => ({
    backgroundColor: "#5a7dff",
    fontWeight: "bold",
    color: "white",
    fontSize: "0.75rem",
    [theme.breakpoints.up("md")]: {
        fontSize: "0.875rem",
    },
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
    padding: theme.spacing(1),
    fontSize: "0.75rem",
    borderBottom: "1px solid #e0e0e0",
    [theme.breakpoints.up("md")]: {
        fontSize: "0.875rem",
        padding: theme.spacing(1.5),
    },
}));

export const SummaryBox = styled(Box)(({ theme }) => ({
    background: "white",
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    width: "100%",
    [theme.breakpoints.up("md")]: {
        width: "auto",
    },
}));

export const SummaryRow = styled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(1),
    [theme.breakpoints.up("md")]: {
        marginBottom: theme.spacing(1.5),
    },
}));

export const SummaryLabel = styled(Box)(({ theme }) => ({
    color: "black",
    fontWeight: 500,
    fontSize: "0.8rem",
    [theme.breakpoints.up("md")]: {
        fontSize: "0.875rem",
    },
}));

export const SummaryValue = styled(TextField)(({ theme }) => ({
    width: "100px",
    "& input": {
        textAlign: "right",
        padding: "4px 6px",
        fontWeight: 500,
        color: "black",
        fontSize: "0.75rem",
        [theme.breakpoints.up("md")]: {
            fontSize: "0.875rem",
            padding: "4px 8px",
        },
    },
    [theme.breakpoints.up("md")]: {
        width: "150px",
    },
}));

export const SystemField = styled(TextField)(({ theme }) => ({
    width: "100%",
    background: "white",
    borderRadius: 4,
    [theme.breakpoints.up("md")]: {
        width: "800px",
    },
}));

export const PaymentButton = styled(Button)(({ theme }) => ({
    marginTop: theme.spacing(1),
    [theme.breakpoints.up("md")]: {
        marginTop: theme.spacing(2),
    },
}));
